import {
  scenarioDateComparator,
  scenarioDateFilterParams
} from 'components/AgGridCustomFilters/helpers'

export const SCENARIO_MANAGER = 'SCENARIO_MANAGER'
export const SCENARIO_DASHBOARD = 'SCENARIO_DASHBOARD'
export const SCENARIO_SCHEDULED = 'SCENARIO_SCHEDULED'
export const SCENARIO_PURGER = 'SCENARIO_PURGER'

export const SCENARIO_PURGER_HEADING = 'PurgerPlatform.MAIN_HEADING'
export const SCENARIO_PURGER_ACTIVE_FILTERS =
  'PurgerPlatform.Filterbar.ACTIVE_FILTERS'

export const SCENARIO_SCHEDULED_HEADING = 'ScheduledPlatform.MAIN_HEADING'
export const SCENARIO_SCHEDULED_ACTIVE_FILTERS =
  'ScheduledPlatform.Filterbar.ACTIVE_FILTERS'

export const MY_SCENARIOS = 'MyScenarios'
export const ALL_SCENARIOS = 'AllScenarios'

export const PAGINATION_SIZE = 10

export const STATUS = 'status'
export const SCENARIO_TYPE = 'typeValue'

export const CHARTS_COLOR_THEME = ['#AF144B', '#d13579', '#C3266B', '#991850']

export const WAIT = 'WAIT'
export const DONE = 'DONE'
export const READY = 'READY'
export const ERROR = 'ERROR'
export const RESET = 'RESET'
export const CREATED = 'CREATED'
export const RUNNING = 'RUNNING'
export const DELETED = 'DELETED'
export const DELETING = 'DELETING'
export const CANCELLING = 'CANCELLING'
export const KILLING = 'KILLING'

export const DATE_FORMAT = 'DD/MM/YYYY HH:mm:ss'
export const ISO_DATE_FORMAT = 'YYYY/MM/DD'

export const filterObjects = [
  {
    key: 'name',
    title: 'Filter.Name'
  },
  {
    key: 'username',
    title: 'Filter.Users'
  },
  {
    key: 'typeValue',
    title: 'Filter.Type'
  },
  {
    key: 'status',
    title: 'Filter.Status'
  }
]

export const filterItems = (t) => [
  {
    label: t(`Dashboard.${MY_SCENARIOS}`),
    value: MY_SCENARIOS
  },
  {
    label: t(`Dashboard.${ALL_SCENARIOS}`),
    value: ALL_SCENARIOS
  }
]

export const ScenarioProgressColumn = {
  ERROR: 'error',
  OUTPUT: 'output',
  PLAY: 'play',
  PROGRESS: 'progress',
  LOADING: 'loading',
  TIME_PROGRESS: 'timeProgress'
}

export const ScenarioPlatformActions = {
  DELETE_SCENARIO: 'deleteScenario',
  RESET_SCENARIO: 'resetScenario',
  CANCEL_SCENARIO: 'cancelScenario',
  WARNING_SCENARIO: 'warningScenario',
  KILL_SCENARIO: 'killScenario',
  PROGRESS_SCENARIO: 'progressScenario'
}

export const ScenarioPermissions = {
  CREATE: 'create',
  READ: 'read',
  UPDATE: 'update',
  DELETE: 'delete',
  IMPORT: 'import_',
  EXPORT: 'export'
}

export const columnPropsByType = {
  date: {
    minWidth: 190,
    filter: 'agDateColumnFilter',
    cellRenderer: 'dateRenderer',
    comparator: scenarioDateComparator(DATE_FORMAT),
    filterParams: scenarioDateFilterParams(DATE_FORMAT),
    cellRendererParams: {
      showTime: false
    }
  },
  datetime: {
    minWidth: 190,
    filter: 'agDateColumnFilter',
    cellRenderer: 'dateRenderer',
    comparator: scenarioDateComparator(DATE_FORMAT),
    filterParams: scenarioDateFilterParams(DATE_FORMAT),
    cellRendererParams: {
      showTime: true
    }
  },
  text: {
    minWidth: 180,
    maxWidth: 360,
    cellClass: 'cell-wrap-text'
  },
  number: {
    filter: 'agNumberColumnFilter'
  }
}
